/* Review photo wall. v57: Mud Freaks page gets the dirt bike photos. */
var IFRVCDN='https://cdn.shopify.com/s/files/1/0979/3604/8475/files/';
window.IF_REVIEW_PHOTOS=window.IF_MUD?[
IFRVCDN+'mfp-wild-1.webp?v=1792898568',
IFRVCDN+'mfp-wild-2.webp?v=1792898567',
IFRVCDN+'mfp-wild-3.webp?v=1792898568',
IFRVCDN+'mfp-wild-4.webp?v=1792898567',
IFRVCDN+'mfp-wild-6.webp?v=1792898567',
IFRVCDN+'mfp-wild-7.webp?v=1792898567',
IFRVCDN+'mfp-feed-1.webp?v=1792898568',
IFRVCDN+'mfp-feed-3.webp?v=1792898567'
]:[
IFRVCDN+'if-ugc-tyler.webp',
IFRVCDN+'if-ugc-jake.webp',
IFRVCDN+'if-ugc-emma.webp',
IFRVCDN+'if-ugc-beer.webp?v=1790010806',
"https://cdn.shopify.com/s/files/1/0979/3604/8475/files/ice-freaks-gondola-crew-review.png?v=1791331117",
"https://cdn.shopify.com/s/files/1/0979/3604/8475/files/ice-freaks-snowboard-trio-review.png?v=1791331133",
IFRVCDN+'if-ugc-lift.webp?v=1790008683',
IFRVCDN+'if-lifestyle-1.webp?v=1789994285'
];
